import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, getAllIntegrations, deleteIntegration } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';

import Loading from '../../../components/Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faPlus, faEye } from '@fortawesome/free-solid-svg-icons';

function IntegrationsList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [integrations, setIntegrations] = useState([]);
  const [integrationsSelected, setIntegrationsSelected] = useState([]);
  const [disable, setDisable] = useState(true);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [integrationToDelete, setIntegrationToDelete] = useState(null);

  const history = useHistory();

  const fetchIntegrations = async () => {
    try {
      const response = await getAllIntegrations();
      if (response && response.success && response.data) {
        setIntegrations(response.data);
      } else {
        setIntegrations([]);
      }
      setLoading(false);
    } catch (error) {
      console.error('Erro ao buscar integrações:', error);
      setIntegrations([]);
      setLoading(false);
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    await fetchIntegrations();
  }, [history]);

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  const handleEdit = (integration) => {
    setItemsSelectedToEdit(integration);
    toggleIsChangeFormElements();
    toggleIsHidden();
    history.push('/config/integracoes/editar');
  };

  const handleView = (integration) => {
    setItemsSelectedToEdit(integration);
    history.push('/config/integracoes/visualizar');
  };

  const confirmDelete = (integration) => {
    setIntegrationToDelete(integration);
    setShowConfirmDelete(true);
  };

  const handleDelete = async () => {
    if (!integrationToDelete) return;

    try {
      const response = await deleteIntegration(integrationToDelete.id_integration);
      if (response && response.success) {
        await fetchIntegrations();
        setShowConfirmDelete(false);
        setIntegrationToDelete(null);
      } else {
        console.error('Erro ao deletar integração:', response);
      }
    } catch (error) {
      console.error('Erro ao deletar integração:', error);
    }
  };

  const cancelDelete = () => {
    setShowConfirmDelete(false);
    setIntegrationToDelete(null);
  };

  const formatType = (type) => {
    if (!type) return type;
    const typeMap = {
      'whatsapp': 'WhatsApp',
      'sms': 'SMS',
      'webhook': 'Webhook',
      'noah': 'Noah',
      'sgcon': 'Sgcon',
      'api': 'API'
    };
    return typeMap[type.toLowerCase()] || type;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('pt-BR');
  };

  const maskToken = (token) => {
    if (!token || token.length < 8) return '****';
    return token.substring(0, 4) + '***' + token.substring(token.length - 4);
  };

  if (loading) return <Loading />;

  return (
    <div className="container is-fluid">
      <div className="columns">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">LISTA DAS INTEGRAÇÕES</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <div className="columns is-centered">
        <div className="column is-12">
          <div className="box">
            <div className="level">
              <div className="level-left">
                <div className="level-item">
                  <h1 className="title is-4">
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    Gerenciar Integrações
                  </h1>
                </div>
              </div>
              <div className="level-right">
                <div className="level-item">
                  <Link to="/config/integracoes/nova" className="button is-primary">
                    <span className="icon">
                      <FontAwesomeIcon icon={faPlus} />
                    </span>
                    <span>Nova Integração</span>
                  </Link>
                </div>
              </div>
            </div>

            {integrations.length === 0 ? (
              <div className="notification is-info">
                <p className="has-text-centered">
                  <strong>Nenhuma integração encontrada</strong>
                </p>
                <p className="has-text-centered">
                  Clique em "Nova Integração" para criar sua primeira integração.
                </p>
              </div>
            ) : (
              <div className="table-container">
                <table className="table is-fullwidth is-striped is-hoverable">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Account Code</th>
                      <th>DDD</th>
                      <th>URL</th>
                      <th>Token</th>
                      <th>Mensagem</th>
                      <th>Template</th>
                      <th>Criado em</th>
                      <th>Atualizado em</th>
                      <th className="has-text-centered">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {integrations.map((integration) => (
                      <tr key={integration.id_integration}>
                        <td>
                          <strong>#{integration.id_integration}</strong>
                        </td>
                        <td>
                          <span className="tag is-link is-light">
                            {integration.accountcode}
                          </span>
                        </td>
                        <td>
                          <span className="tag is-primary">
                            {formatType(integration.type)}
                          </span>
                        </td>
                        <td>
                          <span 
                            className="is-size-7"
                            title={integration.url}
                          >
                            {integration.url.length > 40 
                              ? `${integration.url.substring(0, 40)}...` 
                              : integration.url
                            }
                          </span>
                        </td>
                        <td>
                          <code className="is-size-7">
                            {maskToken(integration.token)}
                          </code>
                        </td>
                        <td>
                          <span 
                            className="is-size-7"
                            title={integration.message || 'Sem mensagem'}
                          >
                            {integration.message 
                              ? (integration.message.length > 30 
                                  ? `${integration.message.substring(0, 30)}...` 
                                  : integration.message)
                              : <em className="has-text-grey">Sem mensagem</em>
                            }
                          </span>
                        </td>
                        <td>
                          <span className="is-size-7">
                            {integration.template_name ? (
                              <span title={`${integration.template_name} (${integration.template_language || 'pt_BR'})`}>
                                {integration.template_name}
                              </span>
                            ) : (
                              <em className="has-text-grey">-</em>
                            )}
                          </span>
                        </td>
                        <td className="is-size-7">
                          {formatDate(integration.created_at)}
                        </td>
                        <td className="is-size-7">
                          {formatDate(integration.updated_at)}
                        </td>
                        <td>
                          <div className="buttons is-centered">
                            <button
                              className="button is-small is-info"
                              onClick={() => handleView(integration)}
                              title="Visualizar"
                            >
                              <FontAwesomeIcon icon={faEye} />
                            </button>
                            <button
                              className="button is-small is-warning"
                              onClick={() => handleEdit(integration)}
                              title="Editar"
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="button is-small is-danger"
                              onClick={() => confirmDelete(integration)}
                              title="Excluir"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <div className="level mt-4">
              <div className="level-left">
                <div className="level-item">
                  <p className="is-size-7 has-text-grey">
                    Total: {integrations.length} integração(ões)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Confirmação de Exclusão */}
      <div className={`modal ${showConfirmDelete ? 'is-active' : ''}`}>
        <div className="modal-background" onClick={cancelDelete}></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Confirmar Exclusão</p>
            <button 
              className="delete" 
              aria-label="close"
              onClick={cancelDelete}
            ></button>
          </header>
          <section className="modal-card-body">
            <p>
              Tem certeza que deseja excluir a integração{' '}
              <strong>#{integrationToDelete?.id_integration}</strong> do tipo{' '}
              <strong>{formatType(integrationToDelete?.type || '')}</strong>?
            </p>
            <p className="has-text-danger mt-3">
              <strong>Esta ação não pode ser desfeita!</strong>
            </p>
          </section>
          <footer className="modal-card-foot">
            <button 
              className="button is-danger"
              onClick={handleDelete}
            >
              Sim, Excluir
            </button>
            <button 
              className="button"
              onClick={cancelDelete}
            >
              Cancelar
            </button>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default IntegrationsList;
